import {apiService} from '../apiService';
import type {CreateVendorRequest, Expense, Vendor} from 'shared-types';

export const vendorApi = {
    // GET routes based on actual backend
    getAll: (): Promise<Vendor[]> =>
        apiService.get('/vendor'),

    getById: (id: string): Promise<Vendor> =>
        apiService.get(`/vendor/${id}`),

    getExpensesByVendorId: (vendorId: string): Promise<Expense[]> =>
        apiService.get(`/vendor/getExpensesByVendorId/${vendorId}`),

    // POST routes
    create: (vendor: CreateVendorRequest): Promise<Vendor> =>
        apiService.post('/vendor', vendor),

    uploadDocument: (id: string, file: File, additionalData?: Record<string, any>): Promise<any> =>
        apiService.uploadFile(`/vendor/${id}/documents`, file, additionalData),

    // DELETE routes
    delete: (id: string): Promise<void> =>
        apiService.delete(`/vendor/${id}`),
};